const aaa = [
	{
		path: "stock",
		component: () => import("@/views/huotiguanli/stock.vue"),
		meta:{title:'建议库存',keepAlive:true},
	},
	// {
	// 	path: "detail",
	// 	component: () => import("@/views/huotiguanli/detail.vue"),
	// 	meta:{title:'详情'},
	// }
]
export default aaa;